"use client";

import { StatisticsSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import { renderGeneratedSection } from "./generated-section-renderer";
import { statisticsRenderers } from "./generated-sections-registry";

const GeneratedStatisticsSection: FC<StatisticsSectionProps> = (props) => {
  return renderGeneratedSection(
    props,
    statisticsRenderers,
    "Home4",
    (x) => x.setting.Appearance?.Key,
  );
};

export default GeneratedStatisticsSection;
